import React from 'react';
import { Users, BarChart2, Brain } from 'lucide-react';

const BottomNav = ({ currentPage, setCurrentPage }) => {
  const navItems = [
    { id: 'player', label: 'Players', icon: Users },
    { id: 'team', label: 'Teams', icon: BarChart2 },
    { id: 'headtohead', label: 'Head to Head', icon: Brain }
  ];

  return (
    <>
      {/* Desktop Navigation - stays at top */}
      <div className="hidden md:flex space-x-4 mb-8">
        {navItems.map(({ id, label }) => (
          <button
            key={id}
            onClick={() => setCurrentPage(id)}
            className={`px-6 py-3 rounded-xl font-semibold transition-all duration-300 ${
              currentPage === id
                ? 'bg-gradient-to-r from-emerald-500 to-blue-500 text-white'
                : 'bg-gray-800/50 text-gray-400 hover:text-white hover:bg-gray-700/50'
            }`}
          >
            {label}
          </button>
        ))}
      </div>

      {/* Mobile Bottom Navigation */}
      <div className="md:hidden fixed bottom-0 left-0 right-0 bg-gray-900/95 backdrop-blur-lg border-t border-gray-800 z-50">
        <div className="flex justify-around items-center h-16">
          {navItems.map(({ id, label, icon: Icon }) => (
            <button
              key={id}
              onClick={() => setCurrentPage(id)}
              className={`flex flex-col items-center justify-center w-full h-full space-y-1 transition-all duration-300 ${
                currentPage === id
                  ? 'text-emerald-500'
                  : 'text-gray-400 hover:text-gray-200'
              }`}
            >
              <Icon size={20} />
              <span className="text-xs font-medium">{label}</span>
            </button>
          ))}
        </div>
      </div>

      {/* Mobile Bottom Padding */}
      <div className="h-16 md:hidden" />
    </>
  );
};

export default BottomNav;